import { useNavigate } from "react-router-dom";
import { Button } from "@jhool-io/fe-components";
import { cn } from "../../utils/helpers";

interface BackLinkProps {
    /** Route to naviagate back to */
    to?: string;
    /** Optional class for styling */
    buttonClass?: string;
    /** Optional style prop to add inline styles */
    style?: Record<string, string>;
    /** function to run if button is not a link */
    onClick?: () => void;
    /** Text to display instead of "Back" */
    backText?: string;
    /** Optional button title  */
    title?: string;
}

export default function BackLink({
    to,
    buttonClass,
    style,
    onClick,
    backText,
    title,
}: BackLinkProps) {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        return to ? navigate(to) : onClick?.();
    };

    return (
        <Button
            size="auto"
            variant="can-hover"
            onClick={handleButtonClick}
            className={cn(
                "px-2 flex items-center text-base text-textSec font-medium",
                buttonClass
            )}
            style={style}
            aria-label="back button"
            title={title}
            iconLeft={
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="size-3.5"
                >
                    <line x1="19" y1="12" x2="5" y2="12" />
                    <polyline points="12 19 5 12 12 5" />
                </svg>
            }
        >
            {backText || "Back"}
        </Button>
    );
}
